module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('header', [_c('h1', [_vm._v(" Welcome to Sporte ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "32px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToLogin
    }
  }, [_vm._v("\n          Login\n          "), _c('i', {
    staticClass: "el-icon-arrow-right el-el-icon-right"
  })])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToBooking
    }
  }, [_vm._v("\n          Book Now\n          "), _c('i', {
    staticClass: "el-icon-arrow-right el-el-icon-right"
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e1d3e61","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 726
// module chunks = 19